jQuery(document).ready(function($) {
  if ($('.podcast-archive__filter').length > 0) {
      // Add Spinner
      $('.spinner').addClass('loading');

      doFilterPodcasts();

      $('#filter-season').change(function() {

        // If we are pulling first page, remove all previous posts
        $('.results-container__posts').empty();
        
        // Set page to 1 as we are new-filtering.
        $('#paged').val('1');
        doFilterPodcasts();
      });

      // Add control for "Clear All".
      $('.podcast-archive__filter-clear').click(function() {
        var paged = 1;
        $('#paged').val(paged);

        // Set all seasons as default when Clearing
        var selectize = $('#filter-season')[0].selectize;
        selectize.setValue('all'); // This triggers the reload of the page

        // Re-load Podcast Resources
        //doFilterPodcasts();
      });

      $('.podcast-archive__load-more').click(function () {
          var paged = parseInt($('#paged').val()) + 1;
          $('#paged').val(paged);

          // Load more Podcast Resources
          doFilterPodcasts();
      });
  }
});

function doFilterPodcasts() {

  // Hide pagination 
  $('.podcast-archive__load-more').css('display', 'none');

  // Show loading
  $('.spinner').addClass('loading');
  
  // If we are pulling first page, remove all previous posts
  if ($('#paged').val() == 1) {
    $('.results-container__posts').empty();
  }

  // Build URL Parameters
  // buildURLParameters(terms, $('input[name=date-range]:checked').val(), date_range, orderby);

  var season = getFilterSeason();

  // AJAX call
  $.ajax({
      url: ajax_var.url,
      nonce: ajax_var.nonce,
      method: 'POST',
      data: {
        action: 'taoti_archive_query_more',
        post_type: 'podcasts',
        season: season,
        paged: $('#paged').val(),
      }, success: function (response) {

          if (response && response.success) {
              // Add new content
              if (response.data.count > 0) {

                  // Scroll To last post row if page is not the first one
                  // if ($('#paged').val() != 1) {
                  //     $('html, body').animate({scrollTop: $('.results-container__loader').offset().top}, 'slow');
                  // }

                  $('.results-container__posts').append(response.data.html);
              } else {
                  $('.results-container__posts').html('No results found');
                  $('.results-found-qty').html('0 results showing');
              }

              // Hide loading
              $('.spinner').removeClass('loading');

              // Check if I need to show again the pagination
              if (response.data.see_more) {
                $('.podcast-archive__load-more-wrapper').css('display', 'flex');
                $('.podcast-archive__load-more').css('display', 'flex');
              }
          }
      }, error: function (error) {
        console.log(error);

          // Hide loading
          $('.spinner').removeClass('loading');
      }
  });
}

function getFilterSeason() {
    // Term 'slug'.
    let season = $('#filter-season').find(":selected").val()
    
    return season;
}
